import { setupApiInstance } from '@sv-support-sdk/api/src/instance';

import { fetchAuthToken } from './tokens';
import { API_URL, WORKFLOW_API_URL } from '../config';

const instance = setupApiInstance({ baseURL: API_URL });

const workflowInstance = setupApiInstance({ baseURL: WORKFLOW_API_URL });

instance.interceptors.request.use((config) => {
  const token = fetchAuthToken();

  config.headers.Authorization = token ? `Bearer ${token}` : null;

  return config;
});

workflowInstance.interceptors.request.use((config) => {
  const token = fetchAuthToken();

  config.headers.Authorization = token ? `Bearer ${token}` : null;

  return config;
});

export { workflowInstance };

export default instance;
